import { useAuthHeader } from 'react-auth-kit';
import { useQuery, UseQueryOptions, QueryKey } from 'react-query';

export const useAuthQuery = <TData = unknown, TError = unknown>(
  queryKey: QueryKey,
  queryFn: (token: string) => Promise<TData>,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn' | 'enabled'>,
) => {
  const authHeader = useAuthHeader();
  const token = authHeader();

  return useQuery<TData, TError>(
    Array.isArray(queryKey) ? [...queryKey, token] : [queryKey, token],
    () => queryFn(token),
    {
      ...options,
      enabled: !!token, // Only run when token is available
    },
  );
};
